/**
 * Configurações globais da aplicação
 * Centralize aqui todos os links, números e URLs para facilitar manutenção
 */

// WhatsApp
export const WHATSAPP_CONFIG = {
  // Número de suporte (formato: código país + DDD + número, sem símbolos)
  supportNumber: "551153041050",
  // Link do grupo WhatsApp
  groupLink: "https://chat.whatsapp.com/GxfvnWMgkLZBFDViFpRz1z",
  // Link para iniciar conversa com suporte
  supportLink: "https://wa.me/551153041050?text=Olá%2C%20gostaria%20de%20tirar%20uma%20dúvida",
  // Link para agendar mentoria
  mentoriaLink: "https://wa.me/551153041050?text=Olá%20Marlon%2C%20gostaria%20de%20agendar%20uma%20mentoria%20individual",
  // Link para quiz - mensagem de quem veio do quiz e quer ajuda
  quizLink: "https://wa.me/551153041050?text=Oi%21%20Vim%20do%20quiz%20e%20quero%20ajuda%20para%20sair%20das%20apostas",
};

// Hotmart - Links dos produtos
export const HOTMART_CONFIG = {
  // Método Libertação Das Apostas - R$ 29,90
  metodoLda: "https://pay.hotmart.com/K101952745L?checkoutMode=10",
  // Jornada dos 8 Pilares - R$ 297,00
  jornada8Pilares: "https://pay.hotmart.com/E102300480X?off=ctpuxg1e&checkoutMode=10",
  // Upsell - Pacote 5 Mentorias Individuais
  upsell5Mentorias: "https://pay.hotmart.com/E102300480X?off=upsell5mentorias&checkoutMode=10",
  // Upsell - Módulo Completo LDA
  upsellModuloLda: "https://pay.hotmart.com/K101952745L?off=upsellmodulo&checkoutMode=10",
};

// Preços dos Cursos
export const PRICING = {
  metodoLda: {
    name: "Método Libertação Das Apostas",
    priceOriginal: "R$ 199,00",
    price: "R$ 39,90",
    description: "A chave para o recomeço",
  },
  jornada8Pilares: {
    name: "Jornada da Transformação em 8 Pilares",
    priceOriginal: "R$ 1.200,00",
    price: "R$ 297,00",
    priceInstallment: "R$ 30,72",
    installments: "12x",
    description: "Trilhas práticas para evoluir pilar por pilar",
  },
  upsell5Mentorias: {
    name: "Pacote de 5 Mentorias Individuais",
    priceOriginal: "R$ 2.500,00",
    price: "R$ 997,00",
    priceInstallment: "R$ 99,91",
    installments: "12x",
    description: "Acompanhamento direto e personalizado para acelerar sua transformação",
  },
  upsellModuloLda: {
    name: "Módulo Completo do Método LDA",
    priceOriginal: "R$ 497,00",
    price: "R$ 297,00",
    priceInstallment: "R$ 30,72",
    installments: "12x",
    description: "Acesso total a todas as aulas e conteúdos do método",
  },
};

// VSL - Configurações dos vídeos
export const VSL_CONFIG = {
  pilares8: {
    marlon: {
      id: "vid-69498ee3ed1852c895d99c54",
      url: "https://scripts.converteai.net/ff824ec4-2715-4ed7-9baa-65b37bddfb55/players/69498ee3ed1852c895d99c54/v4/player.js",
    },
    camilla: {
      id: "vid-69499667ba8707e946b6583b",
      url: "https://scripts.converteai.net/ff824ec4-2715-4ed7-9baa-65b37bddfb55/players/69499667ba8707e946b6583b/v4/player.js",
    },
  },
  metodolda: {
    marlon: {
      id: "vid-695d6ddc2e6d8eb8b7693c28",
      url: "https://scripts.converteai.net/ff824ec4-2715-4ed7-9baa-65b37bddfb55/players/695d6ddc2e6d8eb8b7693c28/v4/player.js",
    },
    camilla: {
      id: "vid-695d6e17d57dbf783266bafa",
      url: "https://scripts.converteai.net/ff824ec4-2715-4ed7-9baa-65b37bddfb55/players/695d6e17d57dbf783266bafa/v4/player.js",
    },
  },
};

// Quiz Videos - Vídeos específicos do Quiz v1
export const QUIZ_VIDEOS = {
  marlon: {
    id: "vid-693b1b2946583018b52e6ff2",
    url: "https://scripts.converteai.net/ff824ec4-2715-4ed7-9baa-65b37bddfb55/players/693b1b2946583018b52e6ff2/v4/player.js",
    name: "Marlon - Apresentação Quiz",
  },
  camilla: {
    id: "vid-693b1b44c33297495ef7217b",
    url: "https://scripts.converteai.net/ff824ec4-2715-4ed7-9baa-65b37bddfb55/players/693b1b44c33297495ef7217b/v4/player.js",
    name: "Camilla - Confirmação Mentoria",
  },
};

// Depoimentos - Vídeos vturb
export const TESTIMONIALS_CONFIG = {
  jefferson: {
    id: "vid-693a1b8cdee6875e65a4c10a",
    url: "https://scripts.converteai.net/ff824ec4-2715-4ed7-9baa-65b37bddfb55/players/693a1b8cdee6875e65a4c10a/v4/player.js",
    name: "Jefferson",
  },
  mariaClara: {
    id: "vid-693a13f7a358fdc62954374f",
    url: "https://scripts.converteai.net/ff824ec4-2715-4ed7-9baa-65b37bddfb55/players/693a13f7a358fdc62954374f/v4/player.js",
    name: "Maria Clara",
  },
  marciaSoares: {
    id: "vid-693a13f0dee6875e65a4b77f",
    url: "https://scripts.converteai.net/ff824ec4-2715-4ed7-9baa-65b37bddfb55/players/693a13f0dee6875e65a4b77f/v4/player.js",
    name: "Marcia Soares",
  },
  patricia: {
    id: "vid-693a13eae60256fc461b61ad",
    url: "https://scripts.converteai.net/ff824ec4-2715-4ed7-9baa-65b37bddfb55/players/693a13eae60256fc461b61ad/v4/player.js",
    name: "Patricia",
  },
};

// Vídeos do FinalCTA (Página Principal) - DIFERENTES dos VSLs de Marlon/Camila nas rotas /metodolda e /8pilares
export const FINAL_CTA_VIDEOS = {
  metodoLda: {
    id: "vid-693a14f6e891e679e7724c5f",
    url: "https://scripts.converteai.net/ff824ec4-2715-4ed7-9baa-65b37bddfb55/players/693a14f6e891e679e7724c5f/v4/player.js",
    name: "Método LDA - R$ 39,90",
  },
  jornada8Pilares: {
    id: "vid-693a15053ec7593882512878",
    url: "https://scripts.converteai.net/ff824ec4-2715-4ed7-9baa-65b37bddfb55/players/693a15053ec7593882512878/v4/player.js",
    name: "Jornada dos 8 Pilares - R$ 297,00",
  },
  mentoriaIndividual: {
    id: "vid-693a1544a358fdc629543937",
    url: "https://scripts.converteai.net/ff824ec4-2715-4ed7-9baa-65b37bddfb55/players/693a1544a358fdc629543937/v4/player.js",
    name: "Mentoria Individual",
  },
};

// Vídeos de Upsell - Substituir IDs quando tiver os vídeos prontos
export const UPSELL_VIDEOS = {
  // Upsell 5 Mentorias
  upsell5Mentorias: {
    id: "vid-694188b40da2b0a07876066a",
    url: "https://scripts.converteai.net/ff824ec4-2715-4ed7-9baa-65b37bddfb55/players/694188b40da2b0a07876066a/v4/player.js",
    name: "Upsell 5 Mentorias",
  },
  // Upsell Módulo LDA
  upsellModuloLda: {
    id: "vid-6941894090cf878ce7cafd87",
    url: "https://scripts.converteai.net/ff824ec4-2715-4ed7-9baa-65b37bddfb55/players/6941894090cf878ce7cafd87/v4/player.js",
    name: "Upsell Módulo LDA",
  },
};

// Redes Sociais e Links Externos
export const SOCIAL_LINKS = {
  global: {
    facebook: "https://facebook.com",
    twitter: "https://twitter.com",
    youtube: "https://youtube.com",
  },
  marlon: {
    instagram: "https://www.instagram.com/marlon_foradojogo/",
    tiktok: "https://www.tiktok.com/@marlonforadojogo",
    facebook: "https://facebook.com/marlon",
    twitter: "https://twitter.com/marlon",
    youtube: "https://youtube.com/@marlon",
  },
  camilla: {
    instagram: "https://www.instagram.com/millaforadojogo/",
    tiktok: "https://www.tiktok.com/@millaforadojogo",
    facebook: "https://facebook.com/camilla",
    twitter: "https://twitter.com/camilla",
    youtube: "https://youtube.com/@camilla",
  },
};

// Informações gerais
export const COMPANY_INFO = {
  name: "LDA - Libertação Das Apostas",
  shortName: "LDA",
  email: "contato@libertacaodasapostas.com.br",
  whatsappPhone: "(55) 11 5196-6639",
  phone: "+55 11 5196-6639",
};

// Quiz Timers - Tempos em milissegundos para diferentes elementos do quiz
export const QUIZ_TIMERS = {
  marlon_video: 80000, // 80 segundos para o vídeo do Marlon aparecerem os botões
  camilla_video: 20000, // 20 segundos para o vídeo da Camilla aparecerem os botões
  product_page_8pilares: 660000, // 11 minutos para aparecer conteúdo na página /8pilares
  product_page_metodolda: 0, // Sem tempo de espera na página /metodolda
  // Adicione mais timers conforme necessário:
  // outro_elemento: 45000,
};

// Analytics e Tracking (IDs para Facebook Pixel, Google Analytics, etc)
export const TRACKING_CONFIG = {
  facebookPixelId: "", // Adicione seu ID quando tiver
  googleAnalyticsId: "", // Adicione seu ID quando tiver
};

// Textos globais
export const COPY = {
  cta: {
    primary: "Começar agora",
    secondary: "Saiba mais",
  },
  social: {
    whatsappSupport: "Fale conosco no WhatsApp",
    joinGroup: "Entrar no grupo",
    scheduleCall: "Agendar uma sessão",
  },
};

// Quiz Configurations
export const QUIZ_CONFIG = {
  v1: {
    videoId: "PW5eusWx17w",
    showVsl: true,
    questions: [
      {
        id: 1,
        type: "identification",
        title: "Qual dessas situações mais descreve onde você está hoje com as apostas?",
        progress: 15,
        options: [
          { text: "🎰 Sinto que perdi o controle, mesmo tentando parar várias vezes", value: "loss_control" },
          { text: "💸 As apostas já levaram meu dinheiro e minha paz", value: "lost_money" },
          { text: "📉 Acreditei que as apostas seriam uma saída, mas só me afundaram mais", value: "false_hope" },
          { text: "🤫 Carrego isso sozinho. Minto para a família e ninguém sabe do problema", value: "secret" },
        ],
      },
      {
        id: 2,
        type: "impact",
        title: "O quanto as apostas já impactaram sua vida até aqui?",
        progress: 30,
        options: [
          { text: "💰 Prejudicaram meu financeiro e estou individado", value: "financial" },
          { text: "👥 Abalou meus relacionamentos e afastou pessoas importantes", value: "relationships" },
          { text: "😰 Aumentou minha ansiedade/angústia, estou em depressão", value: "emotional" },
          { text: "🌪️ Tudo isso junto. Está ficando difícil segurar sozinho", value: "all" },
          { text: "🤐 Prefiro não falar, só eu sei o quanto está me afetando", value: "skip" },
        ],
      },
      {
        id: 3,
        type: "control",
        title: "Quanto você acredita que já perdeu com as apostas até hoje?",
        progress: 45,
        options: [
          { text: "💵 Menos de R$1.000", value: "less_1k" },
          { text: "💴 Mais de R$1.000", value: "1k_5k" },
          { text: "💶 Mais de R$5.000", value: "5k_10k" },
          { text: "💷 Mais de R$10.000", value: "10k_plus" },
          { text: "🤷 Já perdi muito mais do que tenho noção", value: "unknown" },
          { text: "🔇 Prefiro não responder", value: "skip" },
        ],
      },
      {
        id: 4,
        type: "value",
        title: "Você está prestes a entrar no grupo que pode mudar completamente sua relação com as apostas. Mas antes, precisamos confirmar uma coisa: Você está realmente disposto a seguir o processo?",
        progress: 60,
        benefits: [
          "✅ Me comprometo a aplicar o passo a passo dentro do grupo",
          "🎯 Estou pronto para entender meus gatilhos e mudar minha rotina",
          "🔄 Quero parar de repetir os mesmos erros e recomeçar de verdade",
          "🚀 Aceito receber orientação para sair do ciclo das apostas",
        ],
        buttonText: "✅ SIM, QUERO CONHECER COMO FUNCIONA",
      },
      {
        id: 5,
        type: "video",
        title: "Assista a este vídeo rápido para liberar seu acesso ao grupo:",
        progress: 75,
        videoId: "PW5eusWx17w",
        buttonText: "💬 QUERO ENTRAR NO GRUPO GRATUITO",
      },
      {
        id: 6,
        type: "qualification",
        title: "Antes de finalizar, queremos entender seu perfil para possíveis vagas na mentoria individual.\n\nIsso não afeta sua entrada no grupo, que já está liberada.\n\nMas se, em algum momento, decidir participar da mentoria, precisamos saber se hoje você conseguiria investir R$200.",
        progress: 85,
        options: [
          { text: "✅ Sim, eu tenho ou consigo", value: "yes", flow: "video_camilla" },
          { text: "⏰ Não agora", value: "no", flow: "community" },
        ],
      },
    ],
  },
  v2: {
    videoId: "3P5jXZhhO_w",
    showVsl: true,
    questions: [
      {
        id: 1,
        type: "identification",
        title: "Como você descreveria seu relacionamento com apostas?",
        progress: 15,
        options: [
          { text: "🎰 É meu hobby favorito", value: "hobby" },
          { text: "💭 Penso nisso constantemente", value: "constant" },
          { text: "😰 Isso tira meu sono", value: "stress" },
          { text: "🚨 Virou uma emergência", value: "emergency" },
        ],
      },
      {
        id: 2,
        type: "impact",
        title: "Qual area da sua vida mais sofre?",
        progress: 30,
        options: [
          { text: "💰 Saúde financeira", value: "money" },
          { text: "👥 Convívio social", value: "social" },
          { text: "❤️ Saúde mental", value: "mental" },
          { text: "💪 Energia e disposição", value: "energy" },
          { text: "Todas as anteriores", value: "all" },
        ],
      },
      {
        id: 3,
        type: "control",
        title: "Quanto tempo você gasta com apostas por dia?",
        progress: 45,
        options: [
          { text: "⏰ Menos de 1 hora", value: "less1h" },
          { text: "⏱️ 1-3 horas", value: "1to3h" },
          { text: "⏲️ 3-5 horas", value: "3to5h" },
          { text: "🔴 Mais de 5 horas", value: "more5h" },
        ],
      },
      {
        id: 4,
        type: "value",
        title: "O Método LDA vai te ajudar com:",
        progress: 60,
        benefits: [
          "💰 Recuperar controle do seu dinheiro",
          "💪 Reconstruir sua confiança e autoestima",
          "❤️ Restaurar seus relacionamentos",
          "🧠 Entender e eliminar seus gatilhos",
          "🚀 Criar uma vida significativa, longe das apostas",
        ],
        buttonText: "Entendi, continuar",
      },
      {
        id: 5,
        type: "qualification",
        title: "❤ Se isso pudesse salvar sua vida emocional e financeira…\n\n👉 Hoje você tem ou conseguiria R$200 para começar?",
        progress: 85,
        options: [
          { text: "✅ Sim, tenho ou consigo", value: "yes", flow: "whatsapp" },
          { text: "❌ Não, agora não", value: "no", flow: "community" },
        ],
      },
    ],
  },
};
